import {ref} from 'vue'

export interface UseTouchGesturesOptions {
  onStart?: (e: TouchEvent) => void
  onMove?: (deltaX: number, deltaY: number, e: TouchEvent) => void
  onEnd?: (deltaX: number, deltaY: number, duration: number, e: TouchEvent) => void
}

export function useTouchGestures(options: UseTouchGesturesOptions = {}) {
  const startX = ref(0)
  const startY = ref(0)
  const startTime = ref(0)
  const isDragging = ref(false)
  const isMoving = ref(false)

  const onTouchStart = (e: TouchEvent) => {
    startX.value = e.touches[0].clientX
    startY.value = e.touches[0].clientY
    startTime.value = Date.now()
    isDragging.value = true
    options.onStart?.(e)
  }

  const onTouchMove = (e: TouchEvent) => {
    if (!isDragging.value) return
    isMoving.value = true
    const currentX = e.touches[0].clientX
    const currentY = e.touches[0].clientY
    const deltaX = currentX - startX.value
    const deltaY = currentY - startY.value
    options.onMove?.(deltaX, deltaY, e)
  }

  const onTouchEnd = (e: TouchEvent) => {
    if (!isDragging.value) return
    isDragging.value = false
    isMoving.value = false
    const currentX = e.changedTouches[0].clientX
    const currentY = e.changedTouches[0].clientY
    const deltaX = currentX - startX.value
    const deltaY = currentY - startY.value
    const duration = Date.now() - startTime.value
    options.onEnd?.(deltaX, deltaY, duration, e)
  }

  return {
    onTouchStart,
    onTouchMove,
    onTouchEnd,
    isDragging,
    isMoving,
    startX,
    startY,
  }
}
